import React from 'react'
import '../styles/Navigation.css'
import { serverURL } from '../constants';

function Navigation({ setAuthenticated }) {
  const handleSignOut = () => {
    console.log("Signing out...");
    setAuthenticated(false);

    fetch(`${serverURL}/auth/logout`, {
        method: 'GET',
        credentials: 'include'
    })
        .then((response) => {
            if (response.ok && response.status === 200) {
                return response.json();
            } else {
                throw new Error('Request failed with status ' + response.status);
            }
        })
        .then((data) => {
            if (data.message === 'Successfully logged out.') {
                console.log("User is signed out");
            }
        })
        .catch((err) => {
            console.error(err);
        });
  }

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <div className="nav-title-container">
            <div className="twitch-logo">
              <svg viewBox="0 0 24 24" fill="currentColor" className="twitch-icon">
                <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
              </svg>
            </div>
            <h1 className="nav-title">Clip Digest</h1>
          </div>
          <p className="nav-subtitle">Discover the best moments from your favorite streamers</p>
        </div>
        <button 
          onClick={handleSignOut} 
          className="sign-out-btn"
          aria-label="Sign out of your account"
        >
          <svg className="sign-out-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Sign Out
        </button>
      </div>
    </nav>
  )
}

export default Navigation